import apiClient from '../apiClient';
import { GET_EXCURSION_PRICE_TYPE_URL } from '../apiUrl';

const getExcursionTypeApi = () => {
  return apiClient.get(GET_EXCURSION_PRICE_TYPE_URL);
};

export default getExcursionTypeApi;
